import {Directive, ElementRef, Renderer2} from '@angular/core';
import { RestUrlsConfig } from '@signature-it/ngx-generic/config';
import { ProductImageDirectiveGeneric } from '@signature-it/ngx-generic/directives';

@Directive({
    selector: '[product-image]',
    standalone: false
})
export class ProductSolrImageDirective extends ProductImageDirectiveGeneric {

    constructor(protected restUrlsConf: RestUrlsConfig,
                protected el: ElementRef,
                protected renderer: Renderer2) {
        super(restUrlsConf, el, renderer);
    }

    getProductPic(product: object): string {
        const path = `${this.CDNPrefix}/images/Fittings`;
        return `${path}/${product['product_pic_s']}_${this.size}.jpg`;
    }

    getProductCode(product: object) {
        return product['product_code_s'] || "";
    }

    getProductName(product: object) {
        return product['productPageMainTitle'] || product['FamilyName_s'] || '';
    }

}
